import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoAlimentacion/addTipoAlimentacion`, method: 'POST', body: values, token: token})
}
